import { useQuery } from '@tanstack/react-query';
import { ModuleContext } from 'components/utils/module/ModuleContext';
import { useContext } from 'react';
import { resourcesAPI } from '../../../api/resources';
import { MODULE_TYPES } from '../../../constants';

export const useCustomNumerics = () => {
  const { module } = useContext(ModuleContext);

  return useQuery({
    queryKey: [module?.type, module?.id, 'custom-numerics'],
    queryFn:
      module?.type === MODULE_TYPES.ALGO
        ? resourcesAPI.getCustomNumerics
        : resourcesAPI.getCalculatorCustomNumerics,
    initialData: [],
    initialDataUpdatedAt: 0,
    staleTime: 1000 * 60 * 5,
  });
};
